// シナリオ実行時間(ミリ秒)の表示整形

// フル表記: "1時間23分" / "5分12秒" / "8秒" / "0秒"
export function formatDuration(ms: number): string {
  if (!ms || ms <= 0) return '0秒'
  const totalSec = Math.floor(ms / 1000)
  const h = Math.floor(totalSec / 3600)
  const m = Math.floor((totalSec % 3600) / 60)
  const s = totalSec % 60
  if (h > 0) return `${h}時間${m}分`
  if (m > 0) return `${m}分${s}秒`
  return `${s}秒`
}

// セル等の省スペース表記: "" (0) / "8秒" / "5分" / "1.2時間"
export function formatDurationCompact(ms: number): string {
  if (!ms || ms <= 0) return ''
  const totalSec = Math.round(ms / 1000)
  if (totalSec < 60) return `${totalSec}秒`
  const min = Math.round(totalSec / 60)
  if (min < 60) return `${min}分`
  return `${(ms / 3600000).toFixed(1)}時間`
}
